export default __webpack_public_path__ + "static/media/Block_Dark.8044c1ca.svg";